import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import type { Program } from '@efdigital/ll-addon-data/types/xceed/program';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord } from '@warp-drive/utilities/json-api';

/**
 * Finds a program by id
 * @param programId - The id of the program to find
 * @returns JSON API request to find the program
 */
export function findProgram(programId: string) {
  return findRecord<Program>(DataTypeXceed.Program, programId, {
    ...jsonApiOptions,
    include: ['client', 'contacts'],
  } as FindRecordOptions);
}
